import { AO_PRODUCT_DETAILS_FAILURE, AO_PRODUCT_DETAILS_REQUEST, AO_PRODUCT_DETAILS_SUCCESS, AO_PRODUCT_DETAILS_RESET } from "../../actions";
const initialState = {
    data: null,
    result: null,
    loading: false,
    error: null,
};
const addOrderProductDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case AO_PRODUCT_DETAILS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, result: action.payload });
        case AO_PRODUCT_DETAILS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case AO_PRODUCT_DETAILS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case AO_PRODUCT_DETAILS_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, result: null, error: null });
        default:
            return state;
    }
};
export default addOrderProductDetailsReducer;
